import { version } from '../../package.json';
import { closeDialog } from '@/stores/dialog';

const urlBase =
  'https://github.com/SelfMadeSystem/logbook-bin/raw/refs/heads/main';

const linuxBuild = `${urlBase}/34 Signal Regiment Logbook_${version}_amd64.deb`;
const windowsBuild = `${urlBase}/34 Signal Regiment Logbook_${version}_x64-setup.exe`;

const staticZip = `${location.origin}/static.zip`;

export function DownloadDesktopDialog() {
  const download = (url: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.click();
    a.remove();
  };

  return (
    <div className="stop-scrolling fixed inset-0 z-50 flex items-center justify-center bg-black/50 print:hidden">
      <div
        className="w-96 rounded-lg bg-white shadow-lg"
        onClick={e => e.stopPropagation()}
      >
        <div className="border-b border-gray-200 px-6 py-4">
          <h2 className="text-lg font-medium text-gray-900">
            Download Desktop App
          </h2>
        </div>
        <div className="px-6 py-4">
          <p className="mb-4 text-gray-700">Choose your platform:</p>
          <div className="space-y-2">
            <button
              onClick={() => download(linuxBuild)}
              className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Linux
            </button>
            <button
              onClick={() => download(windowsBuild)}
              className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Windows
            </button>
            <button
              onClick={() => download(staticZip)}
              className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Static (.html files)
            </button>
          </div>
        </div>
        <div className="flex justify-end border-t border-gray-200 px-6 py-4">
          <button
            onClick={closeDialog}
            className="cursor-pointer rounded-md border border-gray-300 px-4 py-2 font-medium text-gray-700 hover:bg-gray-50"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
